import { InjectionToken } from '@angular/core';
import { WorkerPermissionsPort } from '../ports/worker-permissions.port';

export const WORKER_PERMISSIONS_TOKEN = new InjectionToken<WorkerPermissionsPort>(
  'WORKER_PERMISSIONS_TOKEN'
);